import React from 'react';

import Garments from '@features/supplier/component/Garments';

const KeyProducts = ({ supplierInfo }) => {
	return (
		<div className="supplier-product-section section-padding hover-section">
			<h3 className="suplier-title pb-4 font-weight-bold regular-16">Key Products</h3>
			<Garments supplierInfo={supplierInfo} requestFrom="SUPPLIER_DETAILS" />
		</div>
	);
};

export default KeyProducts;
